"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ModalActions = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = __importStar(require("react"));
const prop_types_1 = __importDefault(require("prop-types"));
const react_jss_1 = __importDefault(require("react-jss"));
const modal_actions_style_1 = __importDefault(require("./modal.actions.style"));
class ModalActions extends react_1.default.PureComponent {
    constructor() {
        super(...arguments);
        this.render = () => {
            const { classes, children, adverseAction } = this.props;
            return (jsx_runtime_1.jsx("div", Object.assign({ className: classes.root }, { children: jsx_runtime_1.jsxs("div", Object.assign({ className: classes.actions }, { children: [adverseAction && (jsx_runtime_1.jsx("div", Object.assign({ className: classes.adverseAction }, { children: adverseAction }), void 0)),
                        react_1.Children.map(children, action => (jsx_runtime_1.jsx("div", Object.assign({ className: classes.action }, { children: action }), void 0)))] }), void 0) }), void 0));
        };
    }
}
exports.ModalActions = ModalActions;
ModalActions.propTypes = {
    classes: prop_types_1.default.object.isRequired,
    children: prop_types_1.default.node.isRequired,
    adverseAction: prop_types_1.default.node
};
ModalActions.defaultProps = {
    adverseAction: null
};
exports.default = react_jss_1.default(modal_actions_style_1.default)(ModalActions);
//# sourceMappingURL=modal.actions.js.map